export default __webpack_public_path__ + "static/media/handchem.9e4f5579.svg";